export default __webpack_public_path__ + "static/process5-b4295da58d74ce3d75fdff7d94417b69.png";